import React from 'react'
import cx from 'classnames'
import './style.sass'

export const Paper = ({ children, className = '' }) => {
	const cs = cx('Paper', className)
	return <div className={cs}>{children}</div>
}
